export default __webpack_public_path__ + "static/KeywordResearch_01_03-d2166aaa97280da316ea5ec83b66ab86.webp";